import type { ActivityRecord } from '@proofroom/schema';

export function Activity({ record }: { record: ActivityRecord & { createdAt: string } }) {
  const at = record.updatedAt ?? record.createdAt;
  const date = new Date(at);
  const formatted = `${date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })} at ${date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
  return <div className="meta"><time dateTime={at}>{record.updatedBy ? `${record.updatedBy.name} updated this on ${formatted}` : `Last updated ${formatted}`}</time></div>;
}

export type ListSort = 'updated' | 'oldest' | 'name';
export function sortRecords<T extends ActivityRecord & { name: string; createdAt: string }>(records: T[], sort: ListSort): T[] {
  return [...records].sort((a, b) => sort === 'name' ? a.name.localeCompare(b.name) :
    ((b.updatedAt ?? b.createdAt).localeCompare(a.updatedAt ?? a.createdAt) * (sort === 'oldest' ? -1 : 1) || a.name.localeCompare(b.name)));
}

export function SortSelect({ value, onChange }: { value: ListSort; onChange(value: ListSort): void }) {
  return <label className="list-field">Sort by<select className="input" aria-label="Sort by" value={value} onChange={(e) => onChange(e.target.value as ListSort)}>
    <option value="updated">Last updated: newest first</option><option value="oldest">Last updated: oldest first</option><option value="name">Name: A to Z</option>
  </select></label>;
}
